// @flow
export type UpdateUserPinCount = {
  type: 'UPDATE_USER_PIN_COUNT',
  payload: {
    userId: string,
    increment: number,
  },
};

export function updateUserPinCount(payload: {
  userId: string,
  increment: number,
}): UpdateUserPinCount {
  return {
    type: 'UPDATE_USER_PIN_COUNT',
    payload,
  };
}

export type UpdateUserFollowingCount = {
  type: 'UPDATE_USER_FOLLOWING_COUNT',
  payload: {
    userId: string,
    increment: number,
  },
};

export function updateUserFollowingCount(payload: {
  userId: string,
  increment: number,
}): UpdateUserFollowingCount {
  return {
    type: 'UPDATE_USER_FOLLOWING_COUNT',
    payload,
  };
}

export type UpdateUserScheduledPinCount = {
  type: 'UPDATE_USER_SCHEDULED_PIN_COUNT',
  payload: {
    userId: string,
    increment: number,
  },
};

export function updateUserScheduledPinCount(payload: {
  userId: string,
  increment: number,
}): UpdateUserScheduledPinCount {
  return {
    type: 'UPDATE_USER_SCHEDULED_PIN_COUNT',
    payload,
  };
}

export type UpdateUserSocialNetwork = {
  type: 'UPDATE_USER_SOCIAL_NETWORK',
  payload: {
    socialNetworkName: string,
    connected: boolean,
  },
};

export function updateUserSocialNetwork(
  socialNetworkName: string,
  connected: boolean,
): UpdateUserSocialNetwork {
  return {
    type: 'UPDATE_USER_SOCIAL_NETWORK',
    payload: { socialNetworkName, connected },
  };
}
